module.exports = __webpack_public_path__ + "static/blog-5-2a2c144ab3473f00953be630b76adda2.jpg";